import React from 'react';
import { IconContainer } from './IconContainer';

const RemoveIcon = ({ small, ...props}) => {
    return (
        <IconContainer ariaLabel="remove" cursor="pointer" { ...props }>
            {small
                ? <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14.1667 5.00002H18.3333V6.66669H16.6667V17.5C16.6667 17.721 16.5789 17.933 16.4226 18.0893C16.2663 18.2456 16.0544 18.3334 15.8333 18.3334H4.16667C3.94566 18.3334 3.7337 18.2456 3.57742 18.0893C3.42114 17.933 3.33334 17.721 3.33334 17.5V6.66669H1.66667V5.00002H5.83334V2.50002C5.83334 2.27901 5.92114 2.06704 6.07742 1.91076C6.2337 1.75448 6.44566 1.66669 6.66667 1.66669H13.3333C13.5544 1.66669 13.7663 1.75448 13.9226 1.91076C14.0789 2.06704 14.1667 2.27901 14.1667 2.50002V5.00002ZM15 6.66669H5.00001V16.6667H15V6.66669ZM7.5 9.16669H9.16667V14.1667H7.5V9.16669ZM10.8333 9.16669H12.5V14.1667H10.8333V9.16669ZM7.5 3.33335V5.00002H12.5V3.33335H7.5Z" fill="currentColor"/>
                </svg>
                : <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                    <path d="M17 6h5v2h-2v13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8H2V6h5V3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3zm1 2H6v12h12V8zm-9 3h2v6H9v-6zm4 0h2v6h-2v-6zM9 4v2h6V4H9z" fill="currentColor"/>
                </svg>}
        </IconContainer>
    )
}

export { RemoveIcon };